(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lib-bb-auth-bas", [], factory);
	else if(typeof exports === 'object')
		exports["lib-bb-auth-bas"] = factory();
	else
		root["lib-bb-auth-bas"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(15);

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var login_form_1 = __webpack_require__(16);
	var cx5_ttl_1 = __webpack_require__(17);
	var utils_1 = __webpack_require__(18);
	/**
	 * Creates a BAS Authorization Strategy
	 *
	 * @param config Bas Auth config
	 * @param session Authorization Session
	 * @param utils Authorization Utils
	 * @returns AuthStrategy
	 *
	 * @usageNotes
	 * ### Example:
	 *
	 * ```typescript
	 * import { AUTH, AUTH_STRATEGY } from 'lib-bb-bb-auth';
	 * import { createBasAuth } from 'lib-bb-bb-auth-bas';
	 * ```
	 */
	function createBasAuth(config, session, utils) {
	    var setSession = function () {
	        if (config.sessionTTL) {
	            return utils_1.createSessionFromTTL(session, config.sessionTTL);
	        }
	        else {
	            var req = {
	                method: 'GET',
	                url: "" + config.statusUrl,
	                headers: {
	                    'Content-Type': 'application/json',
	                },
	            };
	            return utils.request(req)
	                .then(function (response) {
	                var expiry = utils_1.ttlToExpiry(JSON.parse(response.body).expires_in);
	                session.create(expiry);
	            });
	        }
	    };
	    var login = function (username, password) {
	        var loginData = {
	            username: username,
	            password: password,
	        };
	        if (config.sessionTTL) {
	            loginData = {
	                j_username: username,
	                j_password: password,
	            };
	        }
	        var req = {
	            method: 'POST',
	            url: "" + config.authUrl,
	            data: utils.encode(loginData),
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded',
	            },
	        };
	        return utils.request(req)
	            .then(setSession)
	            .then(function () {
	            var redirectUri = utils.getQueryStringValue('redirect') || config.landingPageUrl;
	            utils.redirect(redirectUri);
	        });
	    };
	    var redirectToLoginPage = function (redirectPageUrl) {
	        var redirectUri = utils.resolveRedirectUri(config.loginPageUrl, redirectPageUrl || config.landingPageUrl);
	        if (redirectUri) {
	            utils.redirect(redirectUri);
	        }
	    };
	    var logout = function (redirectPageUrl) {
	        return utils.request({
	            method: 'GET',
	            url: config.logoutUrl,
	            headers: {
	                'Content-Type': 'application/json',
	            },
	        })
	            .then(function () {
	            session.destroy();
	            redirectToLoginPage(redirectPageUrl);
	        });
	    };
	    var refresh = function () {
	        return utils.request({
	            method: 'GET',
	            url: config.refreshUrl,
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded',
	            },
	        })
	            .then(function (response) {
	            return setSession();
	        });
	    };
	    var goToLoginPage = redirectToLoginPage;
	    // Call status endpoint only when it might be possible
	    // to have a valid session so we can make sure it's valid.
	    var currentSession = session.getSession();
	    if (currentSession) {
	        setSession()
	            .catch(function () {
	            session.destroy();
	            login_form_1.renderLoginForm(config, login);
	        });
	    }
	    var strategy = {
	        login: login,
	        logout: logout,
	        refresh: refresh,
	        timeToLive: session.getTtl,
	        goToLoginPage: goToLoginPage,
	    };
	    if (config.sessionTTL) {
	        strategy.interceptor = cx5_ttl_1.default(session, config.sessionTTL);
	    }
	    return strategy;
	}
	exports.createBasAuth = createBasAuth;
	exports.createAuthStrategy = createBasAuth;


/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// yes, I know :) but it is experimental and handy
	exports.renderLoginForm = function (config, login) {
	    var currentPageUrl = [location.protocol, '//', location.host, location.pathname].join('');
	    if (currentPageUrl === config.loginPageUrl && config.showLoginForm) {
	        var username_1 = document.createElement('input');
	        username_1.setAttribute('type', 'text');
	        username_1.setAttribute('name', 'username');
	        var password_1 = document.createElement('input');
	        password_1.setAttribute('type', 'text');
	        password_1.setAttribute('name', 'password');
	        var submit = document.createElement('input');
	        submit.setAttribute('type', 'submit');
	        submit.setAttribute('value', 'Submit');
	        var form = document.createElement('form');
	        form.append(username_1, password_1, submit);
	        form.onsubmit = function (event) {
	            event.preventDefault();
	            login(username_1.value, password_1.value)
	                .then(function () {
	                location.assign(config.landingPageUrl);
	            });
	            return false;
	        };
	        document.getElementsByTagName('body')[0].appendChild(form);
	    }
	};


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(18);
	var createCx5TtlInterceptor = function (updateTtl) {
	    return function (httpConfig, next) {
	        updateTtl();
	        return next(httpConfig);
	    };
	};
	exports.default = (function (session, sessionTTL) {
	    var updateTtl = function () {
	        if (sessionTTL) {
	            utils_1.createSessionFromTTL(session, sessionTTL);
	        }
	    };
	    return createCx5TtlInterceptor(updateTtl);
	});


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ttlToExpiry = function (ttl) { return (new Date().getTime() + (ttl * 1000)) / 1000; };
	exports.createSessionFromTTL = function (session, sessionTTL) {
	    var expiry = exports.ttlToExpiry(sessionTTL);
	    session.create(expiry);
	    return Promise.resolve();
	};


/***/ })

/******/ })
});
;
//# sourceMappingURL=lib-bb-auth-bas.js.map


//////////////////
// WEBPACK FOOTER
// ../~/lib-bb-auth-bas/scripts/lib-bb-auth-bas.js
// module id = 8
// module chunks = 1